/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronLeft = createReactComponent("chevron-left", "IconChevronLeft", [
  ["path", { d: "M15 6l-6 6l6 6", key: "svg-0" }]
]);

export { IconChevronLeft as default };
//# sourceMappingURL=IconChevronLeft.js.map
